import { render, staticRenderFns } from "./AuthenticationSucceed.vue?vue&type=template&id=7fee64bc&scoped=true&lang=html&"
import script from "./AuthenticationSucceed.vue?vue&type=script&lang=js&"
export * from "./AuthenticationSucceed.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationSucceed.vue?vue&type=style&index=0&id=7fee64bc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee64bc",
  null
  
)

export default component.exports